import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import SubjectFields from './SubjectFields'

export const SubjectEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <SubjectFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default SubjectEdit
